import { render, staticRenderFns } from "./UserMgmtDetail.vue?vue&type=template&id=44ac5f0c&scoped=true&"
import script from "./UserMgmtDetail.vue?vue&type=script&lang=js&"
export * from "./UserMgmtDetail.vue?vue&type=script&lang=js&"
import style0 from "./UserMgmtDetail.vue?vue&type=style&index=0&id=44ac5f0c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ac5f0c",
  null
  
)

export default component.exports